module.exports = __webpack_public_path__ + "static/media/boleto.21d3d8b2.svg";